export enum SolutionStatus {
  Draft = 'draft',
  Design = 'design',
  Making = 'madeing',
  Finish = 'finish',
  Cancel = 'cancel',
}

const SOLUTION_STATUS_TEXT: Record<SolutionStatus, string> = {
  [SolutionStatus.Draft]: '待开始',
  [SolutionStatus.Design]: '设计中',
  [SolutionStatus.Making]: '制作中',
  [SolutionStatus.Finish]: '完成',
  [SolutionStatus.Cancel]: '已取消',
};

export function solutionStatusText(status: unknown): string {
  const value = String(status ?? '').trim();
  if (!value) return '—';
  return SOLUTION_STATUS_TEXT[value as SolutionStatus] ?? value;
}
